import { render } from "./Alert.vue?vue&type=template&id=40059f79&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=40059f79&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40059f79"

export default script